import React from "react";
import MainMenu from "./MainMenu";
import MenuReception from "./MenuReception";

export default function AdminLeft() {

  const role =
    localStorage.getItem("userRole") || "";

  return (
    <div>

      {/* =====================================================
          BRAND
      ===================================================== */}

      <div className="medicare-brand">

        <div className="medicare-brand-icon">

          <i
            className="fa fa-stethoscope"
            aria-hidden="true"
          ></i>

        </div>

        <div className="medicare-brand-text">

          <span className="medicare-brand-name">
            MediCare
          </span>

          <span className="medicare-version">
            2.0
          </span>

          <span className="medicare-tagline">
            Smart Healthcare Management
          </span>

        </div>

      </div>


      {/* =====================================================
          ROLE BASED MENU
      ===================================================== */}

      <div style={{ marginTop: "10px",height:'80vh',overflowY:'auto' }}>

        {/* DOCTOR */}

        {role === "Doctor" && (
          <MainMenu />
        )}


        {/* RECEPTION */}

        {role === "Reception" && (
          <MenuReception />
        )}


        {/* NURSING STATION */}

        {role === "Nursing Station" && (
          <MenuReception />
        )}


        {/* ANY OTHER ROLE */}

        {![
          "Doctor",
          "Reception",
          "Nursing Station"
        ].includes(role) && (
          <MenuReception />
        )}

      </div>

    </div>
  );
}